// Нэвтрэх — сурагч, эцэг эх (Tomujin DS): солигдох бүтэн дэлгэцийн зураг + бараан давхарга, цагаан лого,
// "Сурагчийн дотоод систем" + "Миний / Томүжин." бичигдэж буй гарчиг, голд цагаан нэвтрэх карт.
// Нэвтрэлт: applicant/login (имэйл + нууц үг); нууц үг мартсан бол имэйлээр түр нууц үг илгээнэ.
import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button, Modal, message } from "antd";
import { FaRegEnvelope } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import ls from "utils/ls";
import { instance } from "utils/axios";
import { AuthContext } from "contexts";
import logoWhite from "assets/images/logo-white.png";
import s1 from "assets/images/login/slide-1.jpg";
import s2 from "assets/images/login/slide-2.jpg";
import s3 from "assets/images/login/slide-3.jpg";
import s4 from "assets/images/login/slide-4.jpg";
import s5 from "assets/images/login/slide-5.jpg";
import s6 from "assets/images/login/slide-6.jpg";

const SLIDES = [[s1, "center 45%"], [s2, "center 55%"], [s3, "center 40%"], [s4, "center 60%"], [s5, "center 45%"], [s6, "center 60%"]];
const WORDS = ["Томүжин.", "Суралцахуй.", "Ирээдүй.", "Хүрээлэл.", "Сургууль."];
const ACCENT = "#f2cd30";
const SLIDE_MS = 5000;

const reducedMotion = () => { try { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) { return false; } };

// Үг бичигдэж, арилж солигдоно; "хөдөлгөөн багасгах" тохиргоотой бол 2.2с тутам шууд солигдоно
function useTyped() {
  const [typed, setTyped] = useState(WORDS[0]);
  useEffect(() => {
    let alive = true;
    let t;
    let w = 0;
    let c = WORDS[0].length;
    let del = true;
    if (reducedMotion()) {
      const iv = setInterval(() => { w = (w + 1) % WORDS.length; setTyped(WORDS[w]); }, 2200);
      return () => clearInterval(iv);
    }
    const tick = () => {
      if (!alive) return;
      let delay;
      if (del) {
        c -= 1;
        if (c <= 0) { c = 0; del = false; w = (w + 1) % WORDS.length; delay = 220; } else delay = 28;
      } else {
        c += 1;
        if (c >= WORDS[w].length) { del = true; delay = 1500; } else delay = 55;
      }
      setTyped(WORDS[w].slice(0, c));
      t = setTimeout(tick, delay);
    };
    t = setTimeout(tick, 1500);
    return () => { alive = false; clearTimeout(t); };
  }, []);
  return typed;
}

// Зураг 5с тутам уусаж солигдоно; одоогийн болон дараагийн зургийг л ачаална (бүх 6-г нэг дор биш)
function useSlide() {
  const [cur, setCur] = useState(0);
  const [seen, setSeen] = useState(() => new Set([0, 1]));
  useEffect(() => {
    if (reducedMotion()) return undefined;
    const iv = setInterval(() => setCur((x) => {
      const n = (x + 1) % SLIDES.length;
      setSeen((s) => (s.has((n + 1) % SLIDES.length) ? s : new Set([...s, (n + 1) % SLIDES.length])));
      return n;
    }), SLIDE_MS);
    return () => clearInterval(iv);
  }, []);
  return [cur, seen];
}

const Eye = ({ off }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {off ? <>
      <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" /><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
      <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" /><path d="m2 2 20 20" />
    </> : <><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" /><circle cx="12" cy="12" r="3" /></>}
  </svg>
);

const inputCls = (bad) => `w-full h-12 md:h-11 px-3 text-base rounded-[10px] border bg-white text-[#1c1c1c] outline-none transition focus:ring-2 ${bad ? "border-[#dc2626] focus:ring-red-200" : "border-[#e5d8f5] focus:border-[#5c1090] focus:ring-[#efe6f7]"}`;

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const origin = location.state?.from?.pathname || "/";
  const { action, state } = useContext(AuthContext);
  const typed = useTyped();
  const [cur, seen] = useSlide();
  const [f, setF] = useState({ email: "", password: "" });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (state.token) navigate("/", { replace: true });
  }, [state.token]); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = (e) => {
    e.preventDefault();
    if (!f.email.trim() || !f.password) return setErr("Имэйл, нууц үгээ оруулна уу");
    ls.remove("remember");
    setLoading(true);
    instance({ method: "post", url: "applicant/login", data: { email: f.email.trim(), password: f.password } })
      .then((res) => { action.login(res.data.token, res.data); navigate(origin); })
      .catch((er) => {
        // interceptor ерөнхий toast харуулна; талбарын доор ч богино алдаа үлдээнэ
        const d = er?.response?.data;
        setErr(Array.isArray(d?.value) ? d.value[0]?.msg : d?.value || d?.error || d?.message || "Нэвтэрч чадсангүй");
      })
      .finally(() => setLoading(false));
  };
  const set = (k) => (e) => { setF({ ...f, [k]: e.target.value }); setErr(null); };

  // ── Нууц үг мартсан ──
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotForm] = Form.useForm();
  const handleForgot = async (v) => {
    setForgotLoading(true);
    try {
      await instance({ method: "post", url: "applicant/forgot-password", data: { email: v.email } });
      message.success("Шинэ түр нууц үгийг таны имэйл рүү илгээлээ. Имэйлээ шалгана уу.");
      forgotForm.resetFields();
      setForgotOpen(false);
    } catch (e) {
      // interceptor алдааг харуулна
    } finally {
      setForgotLoading(false);
    }
  };
  const forgot = (e) => { e.preventDefault(); forgotForm.setFieldsValue({ email: f.email.trim() }); setForgotOpen(true); };

  return (
    <div className="min-h-screen relative overflow-hidden flex flex-col bg-[#1c1c1c] text-[#1c1c1c]" style={{ fontFamily: "Raleway, Roboto, sans-serif" }}>
      <style>{"@keyframes tjCaret{0%,49%{opacity:1}50%,100%{opacity:0}}@media (prefers-reduced-motion: reduce){.tj-caret{animation:none!important}.tj-slide{transition:none!important}}"}</style>
      <div aria-hidden="true" className="absolute inset-0">
        {SLIDES.map(([src, pos], i) => seen.has(i) && (
          <img key={i} src={src} alt="" className="tj-slide absolute inset-0 w-full h-full object-cover" style={{ objectPosition: pos, opacity: i === cur ? 1 : 0, transition: "opacity 1.2s ease" }} />
        ))}
      </div>
      <div aria-hidden="true" className="absolute inset-0" style={{ background: "rgba(0,0,0,0.45)" }} />

      <header className="relative flex justify-center px-5 md:px-6" style={{ paddingTop: "calc(2.5rem + var(--safe-top, 0px))" }}>
        <img src={logoWhite} alt="Tomujin" className="block w-auto h-6 md:h-9" />
      </header>

      <main className="relative flex-1 w-full box-border px-5 md:px-6 py-6 md:py-10 flex flex-col items-center justify-center gap-7 md:gap-9">
        <div className="flex flex-col items-center gap-3 md:gap-4 w-full">
          <p className="m-0 text-xs font-bold uppercase" style={{ letterSpacing: "0.12em", color: ACCENT }}>Сурагчийн дотоод систем</p>
          <h1 aria-label="Миний Томүжин." className="m-0 w-full text-center font-extrabold uppercase text-white text-[40px] md:text-[clamp(2.5rem,5.4vw,5rem)]" style={{ lineHeight: 0.98, letterSpacing: "-0.02em" }}>
            <span aria-hidden="true" className="block">Миний</span>
            <span aria-hidden="true" className="block" style={{ minHeight: "0.98em", color: ACCENT }}>
              {"​"}{typed}<span className="tj-caret" style={{ display: "inline-block", width: "0.07em", height: "0.8em", marginLeft: "0.06em", verticalAlign: "-0.04em", background: ACCENT, animation: "tjCaret 0.9s steps(1) infinite" }} />
            </span>
          </h1>
        </div>

        <div className="w-full max-w-[440px] box-border p-6 md:p-8 bg-white rounded-2xl" style={{ boxShadow: "0 20px 25px -5px rgba(0,0,0,0.25), 0 8px 10px -6px rgba(0,0,0,0.2)" }}>
          <form onSubmit={submit} noValidate className="flex flex-col gap-[18px] md:gap-5">
            <div className="flex flex-col gap-2">
              <label htmlFor="sp-login-user" className="text-sm font-semibold text-[#1c1c1c]">Имэйл</label>
              <input id="sp-login-user" name="username" type="email" inputMode="email" autoComplete="username" placeholder="name@tomujin.edu.mn" value={f.email} onChange={set("email")} className={inputCls(err && !f.email)} autoFocus />
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex justify-between items-baseline gap-3">
                <label htmlFor="sp-login-pass" className="text-sm font-semibold text-[#1c1c1c]">Нууц үг</label>
                <a href="#forgot" onClick={forgot} className="hidden md:inline text-sm font-semibold !text-[#5c1090] hover:!text-[#3d1b6e]">Нууц үгээ мартсан уу?</a>
              </div>
              <div className="relative">
                <input id="sp-login-pass" name="password" type={showPw ? "text" : "password"} autoComplete="current-password" placeholder="••••••••" value={f.password} onChange={set("password")} className={`${inputCls(!!err)} pr-12`} aria-invalid={!!err} aria-describedby={err ? "sp-login-err" : undefined} />
                <button type="button" onClick={() => setShowPw(!showPw)} aria-label={showPw ? "Нууц үгийг нуух" : "Нууц үгийг харуулах"} aria-pressed={showPw}
                  className="absolute top-0.5 right-0.5 md:top-0 md:right-0 w-11 h-11 flex items-center justify-center bg-transparent border-0 rounded-[10px] text-[#6e5e8a] cursor-pointer">
                  <Eye off={showPw} />
                </button>
              </div>
              {err && <span id="sp-login-err" role="alert" className="text-sm text-[#dc2626]">{err}</span>}
            </div>
            <button type="submit" disabled={loading} className="w-full h-12 rounded-[10px] border-0 text-base font-bold cursor-pointer disabled:opacity-60 hover:brightness-95 transition" style={{ background: ACCENT, color: "#1c1c1c" }}>
              {loading ? "Нэвтэрч байна…" : "Нэвтрэх"}
            </button>
            <a href="#forgot" onClick={forgot} className="md:hidden self-center min-h-[44px] flex items-center text-sm font-semibold !text-[#5c1090]">Нууц үгээ мартсан уу?</a>
          </form>
        </div>
      </main>

      <footer className="relative px-6 pt-4 text-center text-xs text-white" style={{ lineHeight: 1.33, paddingBottom: "calc(1.5rem + var(--safe-bottom, 0px))" }}>© {new Date().getFullYear()} Томүжин Алтернатив Сургууль</footer>

      {/* ── Нууц үг сэргээх modal ── */}
      <Modal open={forgotOpen} onCancel={() => { forgotForm.resetFields(); setForgotOpen(false); }} footer={null} centered width={420} title="Нууц үг сэргээх">
        <p style={{ color: "#555", marginBottom: 16 }}>Бүртгэлтэй имэйл хаягаа оруулна уу. Шинэ түр нууц үгийг имэйлээр илгээнэ.</p>
        <Form form={forgotForm} layout="vertical" onFinish={handleForgot} size="large">
          <Form.Item name="email" rules={[{ required: true, type: "email", message: "Зөв имэйл хаяг оруулна уу" }]}>
            <Input prefix={<FaRegEnvelope />} placeholder="Имэйл хаяг" autoComplete="email" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={forgotLoading} className="w-full">Түр нууц үг илгээх</Button>
        </Form>
      </Modal>
    </div>
  );
}

export default Login;
